<template>
  <div v-if="!exists" class="checklist">
    <div class="checklist-danger">
      <input type="checkbox" name="checkbox" disabled/>
      <label><slot></slot></label>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['exists']
  }
</script>

<style>
  .checklist div {
    clear: both;
    overflow: hidden;
  }

  .checklist label {
    width: 100%;
    border-radius: 3px;
    font-weight: bold;
  }

  .checklist input[type="radio"]:empty,
  .checklist input[type="checkbox"]:empty {
    display: none;
  }

  .checklist input[type="radio"]:empty ~ label,
  .checklist input[type="checkbox"]:empty ~ label {
    position: relative;
    line-height: 2.5em;
    text-indent: 3.25em;
    cursor: pointer;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
  }

  .checklist input[type="radio"]:empty ~ label:before,
  .checklist input[type="checkbox"]:empty ~ label:before {
    position: absolute;
    display: block;
    top: 0;
    bottom: 0;
    left: 0;
    content: '';
    width: 2.5em;
    background: #D1D3D4;
    border-radius: 3px 0 0 3px;
  }

  .checklist input[type="radio"]:hover:not(:checked) ~ label,
  .checklist input[type="checkbox"]:hover:not(:checked) ~ label {
    color: #888;
  }

  .checklist input[type="radio"]:hover:not(:checked) ~ label:before,
  .checklist input[type="checkbox"]:hover:not(:checked) ~ label:before {
    content: '\2714';
    text-indent: .9em;
    color: #C2C2C2;
  }

  .checklist input[type="radio"]:checked ~ label,
  .checklist input[type="checkbox"]:checked ~ label {
    color: #777;
  }

  .checklist input[type="radio"]:checked ~ label:before,
  .checklist input[type="checkbox"]:checked ~ label:before {
    content: '\2714';
    text-indent: .9em;
    color: #333;
    background-color: #ccc;
  }

  .checklist input[type="radio"]:focus ~ label:before,
  .checklist input[type="checkbox"]:focus ~ label:before {
    box-shadow: 0 0 0 3px #999;
  }

  .checklist-default input[type="radio"]:checked ~ label:before,
  .checklist-default input[type="checkbox"]:checked ~ label:before {
    color: #333;
    background-color: #ccc;
  }

  .checklist-primary input[type="radio"]:checked ~ label:before,
  .checklist-primary input[type="checkbox"]:checked ~ label:before {
    color: #fff;
    background-color: #337ab7;
  }

  .checklist-success input[type="radio"]:checked ~ label:before,
  .checklist-success input[type="checkbox"]:checked ~ label:before {
    color: #fff;
    background-color: #5cb85c;
  }

  .checklist-success input[type="radio"]:empty ~ label:before,
  .checklist-success input[type="checkbox"]:empty ~ label:before {
    background: #5cb85c;
  }

  .checklist-danger input[type="radio"]:checked ~ label:before,
  .checklist-danger input[type="checkbox"]:checked ~ label:before {
    color: #fff;
    background-color: #d9534f;
  }

  .checklist-danger input[type="radio"]:empty ~ label:before,
  .checklist-danger input[type="checkbox"]:empty ~ label:before {
    background: #d9534f;
  }

  .checklist-warning input[type="radio"]:checked ~ label:before,
  .checklist-warning input[type="checkbox"]:checked ~ label:before {
    color: #fff;
    background-color: #f0ad4e;
  }

  .checklist-info input[type="radio"]:checked ~ label:before,
  .checklist-info input[type="checkbox"]:checked ~ label:before {
    color: #fff;
    background-color: #5bc0de;
  }
</style>



// WEBPACK FOOTER //
// checklist-item.vue?6c6df5db